module.exports = __webpack_public_path__ + "img/logo.5a1052c8.png";